module.exports = __webpack_public_path__ + "img/button_sports_on.fbf29bcf.png";